<div
  class="w-[88px] h-40 grid place-content-center rounded {{
    error() ? 'border border-warn' : 'border-a-12'
  }}"
  [blazeTooltip]="error()"
  matTooltipPosition="above"
>
  <blaze-availability-time-picker
    [value]="value().from"
    (valueChanged)="onValueChanged($event, 'from')"
  />
</div>
<mat-icon svgIcon="icon_direction_right_16" class="!text-bat-value" />
<div
  class="w-[88px] h-40 grid place-content-center rounded {{
    error() ? 'border border-warn' : 'border-a-12'
  }}"
  [blazeTooltip]="error()"
  matTooltipPosition="above"
>
  <blaze-availability-time-picker
    [value]="value().to"
    (valueChanged)="onValueChanged($event, 'to')"
  />
</div>
